import LanguageControl from '../i18n/LanguageControl';
import { text, languageUrl } from '../i18n/lab';
import { initializeLanguage } from '../i18n/locale';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import labProjects from '../data/labProjects';
import { trackPageView, trackButtonClick } from '../utils/analytics';
import '../styles/lab.css';

const Lab = () => {
  useEffect(() => {
    initializeLanguage('Lab · PeaceTech', text('设计实验与古建图志', 'Design experiments and architectural atlases'));
    trackPageView('Lab');
  }, []);

  return (
    <div className="lab-container">
      <LanguageControl />
      <header className="lab-header">
        <h1>Lab</h1>
        <p>{text('设计实验作品集 — 探索、原型与视觉尝试。', 'Design experiments — explorations, prototypes and visual studies.')}</p>
      </header>

      <div className="lab-grid">
        {labProjects.map((project) => {
          const cover = project.variants[0];
          return (
            <Link
              key={project.id}
              to={languageUrl(`/lab/${project.id}`)}
              className="lab-card"
              onClick={() => trackButtonClick('Lab Project', project.id)}
            >
              <div className="lab-card-preview">
                <iframe
                  className="lab-card-frame"
                  src={languageUrl(cover.src)}
                  title={project.title}
                  loading="lazy"
                  allow="autoplay 'none'; camera 'none'; microphone 'none'"
                  tabIndex={-1}
                  scrolling="no"
                />
                <div className="lab-card-preview-overlay" />
                <span className="lab-card-count">{project.variants.length} {text('个方向', project.variants.length === 1 ? 'direction' : 'directions')}</span>
              </div>
              <div className="lab-card-body">
                <div className="lab-card-titles">
                  <h2>{project.title}</h2>
                  <span className="lab-card-subtitle">{project.subtitle}</span>
                </div>
                <p className="lab-card-summary">{project.summary}</p>
                <div className="lab-card-tags">
                  {project.tags.map((tag) => (
                    <span key={tag} className="lab-tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Lab;
